export { ErrorPage } from './index.pc'
export { MobileErrorPage } from './index.mobile'
